import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { CatalogoServiciosComponent } from "./catalogo-servicios.component";
import { ListaGruposCatalogoComponent } from "./components/ficha-catalogo/lista-grupos-catalogo.component";
import { MatTreeModule } from "@angular/material/tree";

import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../../shared/services/auth/role-guard.service";
import { TablaServiciosComponent } from './components/tabla-servicios/tabla-servicios.component';
import { DialogPrecioServicioComponent } from './components/dialog-precio-servicio/dialog-precio-servicio.component';
import { DialogNuevoServicioComponent } from './components/dialog-nuevo-servicio/dialog-nuevo-servicio.component';

const routes = [
    {
        path: "catalogo",
        component: CatalogoServiciosComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1],
        },
    },
];

@NgModule({
    declarations: [CatalogoServiciosComponent, ListaGruposCatalogoComponent, TablaServiciosComponent, DialogPrecioServicioComponent, DialogNuevoServicioComponent],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        MatTabsModule,
        MatTreeModule,
        MatCheckboxModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        TranslateModule,
        MatToolbarModule,
        FuseSharedModule,
        MatListModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatSlideToggleModule,
        BrowserAnimationsModule
    ],
})
export class CatalogoServiciosModule {}
